import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import useIot from 'components/Common/Iot/Hooks/useIot';
import { PubSub } from 'aws-amplify';
import Form from './Form';

export default function BlockPopup({
  enterpriseId, userToken, onHide, onComplete,
}) {
  const [processCompleted, setProcessCompleted] = useState(false);

  const [terminatedDate, setTerminatedDate] = useState('');
  const [isLocked, setIsLocked] = useState(false);

  useIot();

  useEffect(() => {
    PubSub.subscribe(`user-${userToken}`).subscribe({
      next: ({ value }) => {
        if (value.type === 'enterprise_block_done') {
          setProcessCompleted(true);
          setTerminatedDate(value.terminated_date);
          setIsLocked(value.is_locked);
        }
      },
    });
  }, []);

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          Block Enterprise
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {processCompleted && (
          <>
            {isLocked && (
            <p>
              This enterprise will be blocked on
              {terminatedDate}
              .
              {' '}
              Any active policies will be cancelled on this date.
            </p>
            )}
            {!isLocked && (
              <>
                <p>
                  Enterprise successfully blocked.
                </p>
                <p>
                  All member access and policies will be terminated on
                  {' '}
                  {terminatedDate}
                  .
                </p>
              </>
            )}
            <div className="text-center">
              <Button
                onClick={onComplete}
                bsStyle="primary"
              >
                Close
              </Button>
            </div>
          </>
        )}
        { !processCompleted && (
          <>
            <p>
              Setting a block date will prevent all members from
              accessing services and cancel their policies on the specified date.
            </p>
            <Form enterpriseId={enterpriseId} onClose={onHide} />
            <p>
              Note: This action cannot be undone.
              Please ensure you have notified all affected members before proceeding.
            </p>
          </>
        )}
      </Modal.Body>
    </>
  );
}

BlockPopup.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
};
